import {
  designTokens,
  styled,
  Table,
  TableCell,
  TableHeader,
  TableRow,
} from '@project44/manifest-ds';

export const StyledTable = styled(Table, {
  tableLayout: 'fixed',
  thead: {
    borderBottom: 'none',
  },
  tbody: {
    'tr:last-child td': {
      borderBottom: 'none',
    },
  },
  '& th': {
    minWidth: 0,
    '&:first-of-type': {
      width: '40px',
      paddingRight: '$medium',
    },
    '& td': {
      minWidth: 0,
    },
  },
});

export const MarkerCell = styled(TableCell, {
  paddingLeft: '$large',
  paddingRight: '0',
});

export const TableContainer = styled('div', {
  // Current set by experimentation visually, exploring better ways to do this since this is not always right
  width: 'calc(100% - 32px)',
  maxHeight: 'calc(100vh - 265px)',
  overflowX: 'hidden',
  overflowY: 'auto',
  margin: '$medium',
  boxShadow: '$small',
  borderRadius: '$small',
});

export const StyledTableHeader = styled(TableHeader, {
  tr: {
    th: {
      background: '$background-primary',
      boxShadow: `${designTokens.colorBorderPrimary} 0px -2px 0px 0px inset`,
      border: 'none',
      position: 'sticky',
      top: 0,
    },
  },
});

export const ActiveCircle = styled('div', {
  width: 8,
  height: 8,
  margin: '0 auto',
  background: '$primary-default',
  borderRadius: '8px',
});

export const StyledTableRow = styled(TableRow, {
  cursor: 'pointer',
  '&:hover': {
    td: {
      background: '$palette-grey-50',
    },
  },
  variants: {
    active: {
      true: {
        td: {
          background: '$background-secondary !important',
        },
      },
    },
  },
});
